import { Typography } from "@material-ui/core";

export const Header = (): JSX.Element => {
  return (
    <Typography align="center" variant="h3">
      Mauritius Lifts
    </Typography>
  );
};
